import { Box, Typography, Stack, Paper } from "@mui/material";

function Section({ title, children }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: "1px solid #e5e7eb",
        p: { xs: 2.5, md: 3.5 },
      }}
    >
      <Typography
        sx={{
          fontWeight: 800,
          color: "primary.main",
          fontSize: "1.2rem",
          mb: 1.5,
        }}
      >
        {title}
      </Typography>

      <Stack spacing={1}>{children}</Stack>
    </Paper>
  );
}

function Item({ children }) {
  return (
    <Typography
      sx={{
        fontSize: "0.98rem",
        lineHeight: 1.7,
      }}
    >
      • {children}
    </Typography>
  );
}

function Text({ children, mb = 0 }) {
  return (
    <Typography
      sx={{
        fontSize: "0.98rem",
        lineHeight: 1.7,
        mb,
      }}
    >
      {children}
    </Typography>
  );
}

function SubTitle({ children }) {
  return (
    <Typography
      sx={{
        fontWeight: 700,
        color: "text.primary",
        fontSize: "1rem",
        mt: 0.5,
      }}
    >
      {children}
    </Typography>
  );
}

function RulesSpanish() {
  return (
    <Stack spacing={3}>
      <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.4rem",
          color: "primary.main",
        }}
      >
        Apéndice C: Baloncesto
      </Typography>

      <Typography sx={{ fontWeight: 700 }}>
        Normas FIBA (última edición)
      </Typography>

      <Section title="Excepciones de las reglas">
        <Item>
          Los jugadores no tienen que usar calcetines del mismo color.
        </Item>
      </Section>

      <Section title="Tiempo de juego">
        <Text mb={0.5}>
          Tiempo de calentamiento: Los períodos previos al juego y el entretiempo en la cancha del torneo están reservados únicamente para los equipos participantes vestidos con los uniformes adecuados.
        </Text>

        <Item>4 x 8 cuartos para un juego - reloj parado.</Item>
        <Item>10 minutos de descanso.</Item>
        <Item>2 minutos entre cuartos.</Item>
        <Item>8 segundos para llevar la pelota hasta el centro de la cancha.</Item>
        <Item>Reloj de tiro de 24 segundos.</Item>
        <Item>
          Los períodos de tiempo extra duran la mitad del tiempo de un cuarto normal (4 minutos para juegos de torneo).
        </Item>
        <Item>
          El tiempo no se detendrá en los últimos 2 minutos si uno de los equipos tiene una ventaja de 25 puntos o más. Se aplicarán las mismas reglas durante la prórroga.
        </Item>
        <Item>
          El árbitro llamará a los equipos a comenzar después de 7 minutos del período de calentamiento de 10 minutos.
        </Item>
        <Item>Se aplican las reglas de tiempo muerto de la FIBA.</Item>
        <Item>
          A un equipo que lidera por 25 puntos o más no se le permite presionar en toda la cancha.
        </Item>
      </Section>

      <Section title="Plantillas">
        <Text>
          El Manual de la SAAC describe los límites de plantilla para cada deporte. En baloncesto, el límite máximo es de 10 chicos y 10 chicas. Se necesita un mínimo de 7 jugadores para participar en los torneos de baloncesto autorizados por la SAAC. Las plantillas deben enviarse dos semanas antes del torneo.
        </Text>
      </Section>

      <Section title="Sustitución">
        <Text>Según lo permitido por las reglas de la FIBA.</Text>
      </Section>

      <Section title="Equipo">
        <Text>
          Los niños usarán el balón de baloncesto número 7 y las niñas usarán el balón de baloncesto número 6.
        </Text>
      </Section>

      <Section title="Instalaciones">
        <Text>
          Se requieren al menos dos canchas de baloncesto de tamaño completo con marcador electrónico.
        </Text>
        <Text>
          Se recomienda que las escuelas que organicen partidos de baloncesto tengan relojes de lanzamiento visibles de 24 segundos.
        </Text>
      </Section>

      <Section title="Uniformes">
        <Text>Todos los equipos deben tener uniformes claros y oscuros.</Text>
      </Section>

      <Section title="Funcionarios">
        <Text>
          La procedencia de los funcionarios la determinará la escuela anfitriona. Siempre que sea posible, la escuela anfitriona debería utilizar las organizaciones deportivas internacionales del país anfitrión para oficiar torneos.
        </Text>
        <Text>
          Baloncesto: 2-3 por mesa + 6 árbitros para rotar (4 dentro, 2 fuera) *3 equipos de árbitros.
        </Text>
      </Section>

      <Section title="Clasificaciones y registros">
        <Text mb={0.5}>
          Los equipos se clasificarán de acuerdo con sus registros de victorias y derrotas utilizando el siguiente sistema:
        </Text>

        <Item>Dos (2) puntos por cada partido ganado.</Item>
        <Item>Un (1) punto por cada juego perdido.</Item>
        <Item>Cero (0) puntos por un juego perdido por abandono.</Item>
      </Section>

      <Section title="Desempate Round-Robin">
        <Text mb={0.5}>
          SAAC utilizará las Reglas oficiales de la FIBA para la clasificación de equipos.
        </Text>

        <SubTitle>Desempate FIBA 2020 (21/6 - Idioma incluido)</SubTitle>

        <Text>
          Los equipos se clasificarán según su récord de victorias y derrotas, es decir, 2 puntos de clasificación por cada juego ganado, 1 punto de clasificación por cada juego perdido (incluido el perdido por predeterminado) y 0 puntos de clasificación por un juego perdido por incomparecencia.
        </Text>

        <Text>
          D.1.2 El procedimiento se aplicará para todas las competiciones con sistema de todos contra todos.
        </Text>

        <Text>
          D.1.3 Si 2 o más equipos tienen el mismo récord de victorias y derrotas en todos los juegos del grupo, los partidos entre estos dos o más equipos decidirán la clasificación. Si estos dos o más equipos tienen el mismo récord de victorias y derrotas en los juegos entre ellos, además los criterios se aplicarán en el siguiente orden:
        </Text>

        <Item>
          Mayor diferencia de puntos de juego entre los juegos entre ellos.
        </Item>
        <Item>
          Mayor número de puntos de juego anotados en los juegos entre ellos.
        </Item>
        <Item>
          Mayor diferencia de puntos de juego entre los juegos entre oponentes comunes.
        </Item>
        <Item>
          Mayor número de puntos de juego obtenidos en los partidos entre oponentes comunes.
        </Item>
        <Item>
          Mayor diferencia de puntos de juego de todos los juegos del grupo.
        </Item>
        <Item>
          Mayor número de puntos de juego anotados en todos los partidos del grupo.
        </Item>

        <Text>
          Si el empate persiste antes de que se hayan jugado todos los partidos del grupo, los equipos empatados compartirán la misma clasificación. Si estos criterios aún no pueden decidir al final de la fase de grupos, un sorteo decidirá la clasificación final.
        </Text>

        <Text>
          D.1.4 Si en cualquier nivel de estos criterios uno o más equipos ya están clasificados, se repetirá el procedimiento de D.1.3 desde el principio para todos los equipos restantes no clasificados todavía.
        </Text>

        <SubTitle>
          Si los equipos empatados no han jugado entre sí en el round robin
        </SubTitle>

        <Item>
          Mayor diferencia de puntos de juego entre los juegos entre oponentes comunes.
        </Item>
        <Item>
          Mayor número de puntos de juego obtenidos en los partidos entre oponentes comunes.
        </Item>
        <Item>
          Mayor diferencia de puntos de juego de todos los juegos del grupo.
        </Item>
        <Item>
          Mayor número de puntos de juego anotados en todos los partidos del grupo.
        </Item>

        <Text>
          Si el empate persiste antes de que se hayan jugado todos los partidos del grupo, los equipos empatados compartirán la misma clasificación. Si estos criterios aún no pueden decidir al final de la fase de grupos, un sorteo decidirá la clasificación final.
        </Text>

        <Text>
          D.1.4 Si en cualquier nivel de estos criterios uno o más equipos ya están clasificados, se repetirá el procedimiento de D.1.3 desde el principio para todos los equipos restantes no clasificados todavía.
        </Text>
      </Section>
    </Stack>
  );
}

export default RulesSpanish;